import axios from "axios";
import { getEnv } from "./env";

export const $axios = axios.create({
    baseURL: getEnv("REACT_APP_API_URL"),
});
